import {
  config
} from '../_config'
import {
  authHeader,
  handleResponse
} from '../_helpers'

export const expoTarifasService = {
  addNewExpoDateInscr,
  editExpoDateInscr,
  deleteExpoDateInscr
}


function addNewExpoDateInscr(datos) {

  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoDateInscr`, requestOptions).then(handleResponse)

}

function editExpoDateInscr(datos) {
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoDateInscr/${datos.id}`, requestOptions).then(handleResponse)

}

function deleteExpoDateInscr(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoDateInscr/${id}`, requestOptions).then(handleResponse)

}
